import { AppColors } from "@/styles/colors";
import { Flex, Grid, GridItem, Text } from "@chakra-ui/react";
import dayjs from "dayjs";
import { SellOrderStatus } from "@/constants/entity-status";
import { SellOrderDetail } from "@/pages/grain-requests/sell-orders/schema/sell-order.schema";
import { RequestStatusBadge } from "../badge/RequestStatusBadge";
import { capitalize } from "lodash";

interface Props {
  sellOrder?: SellOrderDetail | null;
}

export const SellOrderMainDataCard = ({ sellOrder }: Props) => {
  return (
    <Grid templateColumns="repeat(2, 1fr)" gap={18}>
      <GridItem>
        <Flex
          flexDir="column"
          padding="12px"
          height="100%"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
          borderRadius="12px"
        >
          <Text
            className="amd-card-title"
            paddingBottom="16px"
            textTransform={"uppercase"}
            paddingX="24px"
            fontWeight={700}
          >
            Detalle
          </Text>
          <Grid templateColumns="repeat(2, 1fr)">
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-title-label">Fecha de solicitud:</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-value-label">
                {dayjs(sellOrder?.fechaSolicitud).format("DD/MM/YYYY")}
              </Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-title-label">Titular:</Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-value-label">{sellOrder?.titular}</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-title-label">Tipo de fijación:</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-value-label">
                {sellOrder?.tipoFijacion ?? "-"}
              </Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-title-label">Estado:</Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-value-label">
                <RequestStatusBadge
                  status={sellOrder?.estado as SellOrderStatus}
                />
              </Text>
            </GridItem>
          </Grid>
        </Flex>
      </GridItem>
      <GridItem>
        <Flex
          flexDir="column"
          padding="12px"
          height="100%"
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
          borderRadius="12px"
        >
          <Text
            className="amd-card-title"
            paddingBottom="16px"
            textTransform={"uppercase"}
            paddingX="24px"
            fontWeight={700}
            visibility="hidden"
          >
            -
          </Text>
          <Grid templateColumns="repeat(2, 1fr)">
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-title-label">Grano:</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-value-label">
                {capitalize(sellOrder?.grano.toLocaleLowerCase())}
              </Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-title-label">Cosecha:</Text>
            </GridItem>
            <GridItem paddingX="24px" paddingY="8px">
              <Text className="account-value-label">{sellOrder?.cosecha}</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-title-label">Es canje:</Text>
            </GridItem>
            <GridItem
              paddingX="24px"
              paddingY="8px"
              backgroundColor={AppColors.BACKGROUND_SECONDARY}
            >
              <Text className="account-value-label">
                {sellOrder?.esCanje ? "Sí" : "No"}
              </Text>
            </GridItem>
          </Grid>
        </Flex>
      </GridItem>
    </Grid>
  );
};
